import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  GetServiceResponse,
  GetServicesResponse,
} from "../../interface/services.interface";

class ServicesService {
  /**
   * 📦 GET ALL SERVICES
   */
  async getServices(): Promise<GetServicesResponse> {
    const response = await apiClient.get<GetServicesResponse>(
      env.PUBLIC_SERVICES_URL
    );

    return response.data;
  }

  /**
   * 📄 GET SINGLE SERVICE
   */
  async getService(id: string): Promise<GetServiceResponse> {
    const response = await apiClient.get<GetServiceResponse>(
      `${env.PUBLIC_SERVICES_URL}/${id}`
    );

    return response.data;
  }
}

export const publicServicesService = new ServicesService();